import {
  createSlice,
  createEntityAdapter
} from '@reduxjs/toolkit'
import { levels } from './levels'

const levelsAdapter = createEntityAdapter()
const emptyInitialState = levelsAdapter.getInitialState();
const filledState = levelsAdapter.upsertMany(emptyInitialState, levels);

const levelsSlice = createSlice({
  name: 'levels',
  initialState: filledState,
  reducers: {}
})

export default levelsSlice.reducer

export const {
  selectAll: selectAllLevels,
  selectById: selectLevelById,
  selectIds: selectLevelIds
} = levelsAdapter.getSelectors(state => state.levels)
